module.exports = __webpack_public_path__ + "img/DiHS_Dashboard_Icon_Team.c9a23dcd.svg";